import React from "react"
import { Link,useLocation } from  'react-router-dom'
import { Navbar, Nav } from "react-bootstrap"

const Header = () => {
//assigning location variable
const location = useLocation();

//destructuring pathname from location
const { pathname } = location;

//Javascript split method to get the name of the path in array
const splitLocation = pathname.split("/");  return (
    <header>
<Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
  <Navbar.Brand href="/">
  <img
        src="/logo_CTS_escala_gris_alta.png"
        width="130"
        height="100"
        className="d-inline-block align-top"
        alt="Cabo Travel Solutions Logo"
      />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
   
    <Nav className="mr-auto justify-content-center" style={{ flex: 1}} >
      <Nav.Link className={splitLocation[1] === "transportations" ? "active" : ""} href="/transportations">Reserve</Nav.Link>
      <Nav.Link className={splitLocation[1] === "services-rates" ? "active" : ""} href="/services-rates">Services & Rates</Nav.Link>
      <Nav.Link className={splitLocation[1] === "vehicles" ? "active" : ""} href="/vehicles">Vehicles & Features</Nav.Link>
      <Nav.Link className={splitLocation[1] === "testimonials" ? "active" : ""} href="/testimonials">Testimonials</Nav.Link>
      <Nav.Link className={splitLocation[1] === "location" ? "active" : ""} href="/location">Locations</Nav.Link>
      <Nav.Link className={splitLocation[1] === "contactus" ? "active" : ""} href="/contactus">Contact Us</Nav.Link>
      <Nav.Link className={splitLocation[1] === "instructions" ? "active" : ""} href="/instructions">Instructions</Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>    
</header>
  )
}

export default Header
